import { Box, IconButton, Tooltip, Skeleton, useToast } from '@chakra-ui/react';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';
import { CreditAgreement } from '@finley-technologies/finley-types';

import { errorToastConfig } from 'packages/common-frontend/constants';
import { useGetCreditFacilityQuery } from 'packages/credit-facility/requests/requests.gql.generated';
import { FiDownload } from 'react-icons/fi';

type ExportJsonButtonProps = {
  creditAgreementFullArtifact: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  creditFacilityId: string;
};
export const ExportJsonButton = ({
  creditAgreementFullArtifact,
  creditFacilityId,
}: ExportJsonButtonProps) => {
  const toast = useToast();
  const { data: creditFacilityData } = useGetCreditFacilityQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = commonUtils.EnvUtils.isProduction()
        ? 'An unexpected error occurred. Please contact Finley for support.'
        : err.message;
      toast(errorToastConfig);
    },
    variables: { creditFacilityId },
  });

  if (!creditFacilityData) {
    return <Skeleton />;
  }

  const creditFacilitySlug = creditFacilityData.creditFacility.slug;

  const downloadCreditAgreementFullArtifact = (
    fullArtifact: CreditAgreement.DomainEntity.CreditAgreementFullArtifact,
  ) => {
    const json = JSON.stringify(fullArtifact);
    const blob = new Blob([json], { type: 'application/json' });
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const nodeEnv = commonUtils.EnvUtils.getEnv();
    link.href = href;
    const envOnStage = nodeEnv === 'prod' ? '-' : `-${nodeEnv}-`;
    link.download = `${creditFacilitySlug}${envOnStage}version${fullArtifact.version}-creditAgreementFullArtifact.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Box display="flex" justifyContent="flex-end">
      <Tooltip label="Export credit agreement JSON">
        <IconButton
          aria-label="download credit agreement JSON"
          icon={<FiDownload />}
          onClick={() =>
            downloadCreditAgreementFullArtifact(creditAgreementFullArtifact)
          }
          variant="ghost"
        />
      </Tooltip>
    </Box>
  );
};
